import(/* webpackMode: "eager" */ "/app/node_modules/next/dist/client/image-component.js");
;
import(/* webpackMode: "eager" */ "/app/node_modules/next/dist/client/link.js");
;
import(/* webpackMode: "eager" */ "/app/public/dataValidator/howItWorks/automated_script.svg");
;
import(/* webpackMode: "eager" */ "/app/public/dataValidator/howItWorks/logical_flow.svg");
;
import(/* webpackMode: "eager" */ "/app/public/dataValidator/howItWorks/spss.svg");
;
import(/* webpackMode: "eager" */ "/app/public/homePage/icons/bullet.svg");
;
import(/* webpackMode: "eager" */ "/app/public/homePage/technology/tabgenLogo.svg");
;
import(/* webpackMode: "eager" */ "/app/public/researchAndConsulting/brandResearch/industries.svg");
;
import(/* webpackMode: "eager" */ "/app/public/slm/icon/home.svg");
;
import(/* webpackMode: "eager" */ "/app/public/slm/work/link_distribution.svg");
;
import(/* webpackMode: "eager" */ "/app/public/slm/work/link_monitoring.svg");
;
import(/* webpackMode: "eager" */ "/app/public/tabgen/c1.png");
;
import(/* webpackMode: "eager" */ "/app/public/tabgen/c2.png");
;
import(/* webpackMode: "eager" */ "/app/public/tabgen/c3.png");
;
import(/* webpackMode: "eager" */ "/app/public/tabgen/c4.png");
;
import(/* webpackMode: "eager" */ "/app/public/tabgen/c5.png");
;
import(/* webpackMode: "eager" */ "/app/public/tabgen/tabulate.png");
;
import(/* webpackMode: "eager" */ "/app/public/tabgen/what_is.png");
;
import(/* webpackMode: "eager" */ "/app/public/tabgen/who_can.png");
;
import(/* webpackMode: "eager" */ "/app/public/tabgen/whychoose.png");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/Component/GetStarted/index.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/Component/Header/index.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/Component/ProductCarousel/NewSlider.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/Component/RavenRippleVideo/index.tsx");
